import Pageable from '@/models/dto/filters/Pageable';

export default class BarcodeRangeFilter extends Pageable {
  /**
   *
   * @param {Pageable} pageable Les informations de pagination
   * @param {LineIdFilter} lineIdFilter le filtre des attributions de fréquence
   * @param {Number} code Le code barre
   * @param {Boolean} deleted Si le code barre est supprimé
   * @param {String} stakeholderId L'identifiant du stakeholder
   * @param {Number} stakeholder L'id du stakeholder
   * @param {Number} lineId L'identifiant de la ligne
   */
  constructor({
                pageable = new Pageable({}),
                lineIdFilter,
                code = null,
                deleted = null,
                stakeholderId = null,
                stakeholder = null,
                lineId = null,
              }) {
    super(pageable);
    this.lineIdFilter = lineIdFilter;
    this.code = code;
    this.deleted = deleted;
    this.stakeholderId = stakeholderId;
    this.stakeholder = stakeholder;
    this.lineId = lineId;
  }
}
